export const STORE_PATTERNS = Object.freeze({
    shopify: '_325x$1'
});
